import dayjs from 'dayjs';

export const GOLDEN_PIN_SLUG = 'golden-pin';

/** Whole calendar days from today to the golden window's end (0 on the last day, never negative). */
export const getGoldenPinDaysLeft = (endDate, now = dayjs()) => {
  if (!endDate) return 0;
  const diff = dayjs(endDate).startOf('day').diff(now.startOf('day'), 'day');
  return Math.max(0, diff);
};

/** Projects (unit-type listings) and off-plan listings can never buy a golden pin. */
export const isGoldenPinIneligibleType = (listing) => {
  if (listing?.is_unit_type_listing === true || listing?.is_offplan_listing === true) return true;
  // Land listings carry no completion_status and are never off-plan.
  const completionStatus = listing?.completion_status;
  return !!completionStatus && completionStatus !== 'ready';
};

export const getGoldenPinTooltip = (t, product, listing) => {
  if (product?.applied) {
    const days = getGoldenPinDaysLeft(product?.time_to_expiry);
    return days === 0 ? t('Golden pin - ends today') : t('goldenPinDaysLeft', { count: days });
  }
  if (!product?.canApply) {
    return isGoldenPinIneligibleType(listing) ? t('Not available on off-plan') : '';
  }
  return t('Apply Golden Pin');
};

/** Golden pin's duration comes from the API (default_expiry_days), never from the listing's expiry. */
export const getGoldenPinDuration = (applicable) => applicable?.default_expiry_days;

export const isGoldenPinProduct = (product) => product?.slug === GOLDEN_PIN_SLUG;

export const GOLDEN_PIN_NUDGE_KEY = 'golden_pin';

/**
 * The golden pin offer from GET /api/surge/users/current `nudges`:
 * { key: 'golden_pin', required_quantity: { '7': 5 }, price: { '7': 50 } } -> { credits: 5, days: 7 }.
 * Null when the entry is missing or malformed, so callers can fall back to copy without numbers.
 */
export const getGoldenPinOffer = (user) => {
  const nudge = user?.parsedNudges?.find((n) => n?.key === GOLDEN_PIN_NUDGE_KEY);
  const quantity = nudge?.requiredQuantity;
  const days = quantity && typeof quantity === 'object' ? Object.keys(quantity)[0] : null;
  const credits = days != null ? Number(quantity[days]) : NaN;
  return days != null && Number.isFinite(credits) ? { credits, days: Number(days) } : null;
};
